module.exports = __webpack_public_path__ + "img/ihealth-white.e6563a1a.svg";